import { render, staticRenderFns } from "./groups-of-concepts-modal-basic-form.vue?vue&type=template&id=2c39078f&"
import script from "./groups-of-concepts-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./groups-of-concepts-modal-basic-form.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports